export var iconSizes = ['extra-small', 'small', 'small-medium', 'medium', 'large', 'extra-large'];
export var iconSizeMapping = {
  'extra-small': '12px',
  small: '16px',
  'small-medium': '20px',
  medium: '24px',
  large: '32px',
  'extra-large': '40px'
};
//# sourceMappingURL=icon.types.js.map